const FLIGHT_DETAILS_ID_DESKTOP = 'flightDetailsDesktop'
const FLIGHT_DETAILS_ID_MOBILE = 'flightDetailsMobile'

export {
  FLIGHT_DETAILS_ID_DESKTOP,
  FLIGHT_DETAILS_ID_MOBILE
}
